<template lang="pug">
  button(
    type="button"
    :class="[{'has-icon': icon}, baseClass]"
    :disabled="isDisabled"
    v-on:click="clickHandler")
    template(v-if="icon")
      img(v-bind:src="icon")
      span {{txt}}
    template(v-else)
      | {{txt}}
</template>

<script>
  export default {
    name: 'PrimaryButton',
    props: {
      baseClass: {
        type: String,
        default: 'btn-prim'
      },
      txt: {
        type: String,
        default: 'primary button'
      },
      icon: {
        type: String,
        default: ''
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      event: {
        type: String,
        default: ''
      }
    },
    methods: {
      clickHandler: function () {
        this.$parent.$emit(this.$props.event)
      }
    }
  }
</script>

<style lang="scss" src="./assets/buttons.scss"></style>
